/** --------------------------------------------------
*
*   components
*   MOBILE NAVIGATION
*
*  -------------------------------------------------- */

(function (Drupal, once, duo) {
  Drupal.behaviors.mobile_nav = {
    selector: '[data-mobile-menu-toggle]',
    selectorSubMenu: '[data-menu-panel]',
    menuTriggers: [],
    panel: [],
    submenus: [],

    attach: function (context, settings) {
      const behavior = Drupal.behaviors.mobile_nav;
      behavior.menuTriggers = once('mobile-menu-once', behavior.selector);

      if (behavior.menuTriggers.length <= 0) {
        return;
      }

      behavior.init();
      behavior.events();
    },

    init: function(context, settings) {
      const behavior = Drupal.behaviors.mobile_nav;

      /* init main mobile nav */
      behavior.panel = document.getElementById('mobile-navigation');

      if (behavior.panel) {
        const settings = {
          'panel': behavior.panel,
          'triggers': behavior.menuTriggers,
          'closeOnResize': true,
          'closeOnBodyClick': false
        };

        new duo.TogglePanel(settings);
      }

      /* init mobile subnavs */
      behavior.submenus = behavior.panel.querySelectorAll(behavior.selectorSubMenu);

      if (behavior.submenus.length > 0) {
        behavior.submenus.forEach(submenu => {
          const triggers = behavior.panel.querySelectorAll('[data-submenu-trigger="' + submenu.id + '"]');

          const settings = {
            'panel': submenu,
            'triggers': triggers,
            'closeOnResize': true,
            'closeOnBodyClick': false
          };

          new duo.TogglePanel(settings);
        });
      }
    },

    events: function() {
      const behavior = Drupal.behaviors.mobile_nav;

      behavior.panel.addEventListener('start:open', () => {
        document.body.classList.add('mobile-nav-open');
      });

      behavior.panel.addEventListener('is:closed', () => {
        document.body.classList.remove('mobile-nav-open');

        /* if submenus, check if a submenu is open and close it after menu is closed */
        if (behavior.submenus.length > 0) {
          behavior.submenus.forEach(submenu => {
            if (submenu.hasAttribute('open')) {
              submenu.removeAttribute('open');
            }
          });
        }
      });

      if (behavior.submenus.length > 0) {
        behavior.submenus.forEach(submenu => {
          submenu.addEventListener('start:open', () => {
            behavior.panel.classList.add('submenu-open');
          });

          submenu.addEventListener('is:closed', () => {
            behavior.panel.classList.remove('submenu-open');
          });
        });
      }
    }
  };
})(Drupal, once, window.duo = window.duo || {});
